import React, { useRef, useState, useEffect } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Row, Col, FormGroup } from 'react-bootstrap';
import Popover from 'react-bootstrap/Popover';
import { MultiSelect } from 'react-multi-select-component';
import { useDispatch, useSelector } from 'react-redux';
import { uniqBy } from 'lodash';
import { useTranslation } from 'react-i18next';
import * as systemMasterAction from '../../Pages/SystemMasters/Store/SystemMasters.action';
import { months, checkArray, createOptions, getYears } from '../helper';
import CustomTooltip from '../Tooltip/CustomTooltip';
import { CurrentYearItemRenderer } from '../Utility/CurrentYearDropdown';

function FilterBy({ onApplyClick, filterActive }) {
  const dispatch = useDispatch();
  const triggerRef = useRef(null);
  const containerRef = useRef(null);
  const ProductTestingData = useSelector((redState) => redState);
  const { UserDetails, SystemMastersDetails, SuppliersDetails } = ProductTestingData;
  const { userInfo } = UserDetails;
  const { brandList, seasonList, category1List, category2List, category3List, category4List } = SystemMastersDetails;
  const { tier2AndAboveList, tier1List } = SuppliersDetails;
  const [supplierOptions, setSupplierOptions] = useState([]);
  const { t } = useTranslation('common');
  const [selectedItems, setSelectedItems] = useState({
    brandId: [],
    seasonId: [],
    year: [],
    month: [],
    suppliers: [],
    catOneId: [],
    catTwoId: [],
    catThreeId: [],
    catFourId: [],
  });
  const brandOption = checkArray(brandList) ? createOptions(brandList, 'name', '_id') : [];
  const seasonOption = checkArray(seasonList) ? createOptions(seasonList, 'name', '_id') : [];
  const yearOption = createOptions(getYears(), 'name', '_id');
  const monthOption = checkArray(months) ? createOptions(months, 'name', '_id') : [];
  const cat1Option = checkArray(category1List) ? createOptions(category1List, 'name', '_id') : [];

  const cat2Option = checkArray(category2List) ? createOptions(category2List, 'name', '_id') : [];

  const cat3Option = checkArray(category3List) ? createOptions(category3List, 'name', '_id') : [];

  const cat4Option = checkArray(category4List) ? createOptions(category4List, 'name', '_id') : [];

  useEffect(() => {
    const suppArray = [...tier1List, ...tier2AndAboveList];
    const upnewArr = uniqBy(suppArray, (e) => e._id);
    setSupplierOptions([...upnewArr]);
  }, [tier2AndAboveList, tier1List]);
  const { brandId, seasonId, year, month, suppliers, catOneId, catTwoId, catThreeId, catFourId } = selectedItems;

  const onFilterChange = (key, val) => {
    switch (key) {
      case 'brandId':
        setSelectedItems((prevState) => ({
          ...prevState,
          brandId: val,
        }));
        break;
      case 'seasonId':
        setSelectedItems((prevState) => ({
          ...prevState,
          seasonId: val,
        }));
        break;
      case 'month':
        setSelectedItems((prevState) => ({
          ...prevState,
          month: val,
        }));
        break;
      case 'year':
        setSelectedItems((prevState) => ({
          ...prevState,
          year: val,
        }));
        break;
      case 'suppliers':
        setSelectedItems((prevState) => ({
          ...prevState,
          suppliers: val,
        }));
        break;
      case 'catOneId':
        setSelectedItems((prevState) => ({
          ...prevState,
          catOneId: val,
        }));
        break;
      case 'catTwoId':
        setSelectedItems((prevState) => ({
          ...prevState,
          catTwoId: val,
        }));
        ForCategoryThree(catOneId, val);
        break;
      case 'catThreeId':
        setSelectedItems((prevState) => ({
          ...prevState,
          catThreeId: val,
        }));
        ForCategoryFour(catOneId, catTwoId, val);
        break;
      case 'catFourId':
        setSelectedItems((prevState) => ({
          ...prevState,
          catFourId: val,
        }));
        break;

      default:
        break;
    }
  };

  const ForCategoryThree = (c1, c2) => {
    const cat3params = {
      categoryOneId: c1,
      categoryTwoId: c2,
      categoryType: 3,
      isActive: true,
      loggedInUserId: userInfo.userId,
    };
    dispatch(systemMasterAction.getCategory3Details(cat3params, false));
  };

  const ForCategoryFour = async (c1, c2, c3) => {
    const cat4params = {
      categoryOneId: c1,
      categoryTwoId: c2,
      categoryThreeId: c3,
      categoryType: 4,
      isActive: true,
      loggedInUserId: userInfo.userId,
    };
    dispatch(systemMasterAction.getCategory4Details(cat4params));
  };

  const onClearClick = () => {
    setSelectedItems((prevState) => ({
      brandId: [],
      seasonId: [],
      year: [],
      month: [],
      suppliers: [],
      catOneId: [],
      catTwoId: [],
      catThreeId: [],
      catFourId: [],
    }));
  };

  return (
    <div ref={containerRef}>
      <CustomTooltip placement="top" tooltipText={t('COMPONENT.PRODUCT_FILTER.FILTER.FILTERS')}>
        <button type="button" aria-label="filter" className={filterActive ? 'btn p-0 active' : 'btn p-0'}>
          <OverlayTrigger
            placement="bottom-end"
            trigger="click"
            rootClose
            container={containerRef}
            target={triggerRef}
            overlay={
              <Popover className="common-filter-popover  popover-xl">
                <Popover.Content>
                  <Row className="form-row">
                    <Col md={4}>
                      <FormGroup>
                        <MultiSelect
                          options={brandOption}
                          className="product-custom-multiselect common-new-multiselect w-100"
                          value={brandOption?.filter((val) => checkArray(brandOption) && brandId.includes(val._id))}
                          labelledBy={t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_BRAND')}
                          overrideStrings={{
                            selectSomeItems: t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_BRAND'),
                          }}
                          onChange={(selected) =>
                            onFilterChange(
                              'brandId',
                              selected.map((val) => val._id),
                            )
                          }
                        />
                      </FormGroup>
                    </Col>{' '}
                    <Col md={4}>
                      <FormGroup>
                        <MultiSelect
                          options={seasonOption}
                          className="product-custom-multiselect common-new-multiselect w-100"
                          value={seasonOption?.filter((val) => checkArray(seasonOption) && seasonId.includes(val._id))}
                          labelledBy={t('COMPONENT.PRODUCT_FILTER.FILTER.SELECTE_SEASON')}
                          overrideStrings={{
                            selectSomeItems: t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_SEASON'),
                          }}
                          onChange={(selected) =>
                            onFilterChange(
                              'seasonId',
                              selected.map((val) => val._id),
                            )
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <MultiSelect
                          ItemRenderer={CurrentYearItemRenderer}
                          options={yearOption}
                          className="product-custom-multiselect common-new-multiselect w-100"
                          value={yearOption?.filter((val) => checkArray(yearOption) && year.includes(val.name))}
                          labelledBy={t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_YEAR')}
                          overrideStrings={{
                            selectSomeItems: t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_YEAR'),
                          }}
                          onChange={(selected) =>
                            onFilterChange(
                              'year',
                              selected.map((val) => val.name),
                            )
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <MultiSelect
                          options={monthOption}
                          className="product-custom-multiselect common-new-multiselect w-100"
                          value={monthOption?.filter((val) => checkArray(monthOption) && month.includes(val.name))}
                          labelledBy={t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_MONTH')}
                          overrideStrings={{
                            selectSomeItems: t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_MONTH'),
                          }}
                          onChange={(selected) =>
                            onFilterChange(
                              'month',
                              selected.map((val) => val.name),
                            )
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <MultiSelect
                          options={supplierOptions}
                          className="product-custom-multiselect common-new-multiselect w-100"
                          value={supplierOptions?.filter((val) => checkArray(supplierOptions) && suppliers.includes(val._id))}
                          labelledBy={t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_PRODUCT_SUPLIER')}
                          overrideStrings={{
                            selectSomeItems: t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_PRODUCT_SUPLIER'),
                          }}
                          onChange={(selected) =>
                            onFilterChange(
                              'suppliers',
                              selected.map((val) => val._id),
                            )
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <MultiSelect
                          options={cat1Option}
                          className="product-custom-multiselect common-new-multiselect w-100"
                          value={cat1Option?.filter((val) => checkArray(cat1Option) && catOneId.includes(val._id))}
                          labelledBy={t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_CATEGORY_ONE')}
                          overrideStrings={{
                            selectSomeItems: t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_CATEGORY_ONE'),
                          }}
                          onChange={(selected) =>
                            onFilterChange(
                              'catOneId',
                              selected.map((val) => val._id),
                            )
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <MultiSelect
                          options={cat2Option}
                          className="product-custom-multiselect common-new-multiselect w-100"
                          value={cat2Option?.filter((val) => checkArray(cat2Option) && catTwoId.includes(val._id))}
                          labelledBy={t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_CATEGORY_TWO')}
                          overrideStrings={{
                            selectSomeItems: t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_CATEGORY_TWO'),
                          }}
                          onChange={(selected) =>
                            onFilterChange(
                              'catTwoId',
                              selected.map((val) => val._id),
                            )
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <MultiSelect
                          options={cat3Option}
                          className="product-custom-multiselect common-new-multiselect w-100"
                          value={cat3Option?.filter((val) => checkArray(cat3Option) && catThreeId.includes(val._id))}
                          labelledBy={t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_CATEGORY_THREE')}
                          overrideStrings={{
                            selectSomeItems: t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_CATEGORY_THREE'),
                          }}
                          onChange={(selected) =>
                            onFilterChange(
                              'catThreeId',
                              selected.map((val) => val._id),
                            )
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <MultiSelect
                          options={cat4Option}
                          className="product-custom-multiselect common-new-multiselect w-100"
                          value={cat4Option?.filter((val) => checkArray(cat4Option) && catFourId.includes(val._id))}
                          labelledBy={t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_CATEGORY_FOUR')}
                          overrideStrings={{
                            selectSomeItems: t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_CATEGORY_FOUR'),
                          }}
                          onChange={(selected) =>
                            onFilterChange(
                              'catFourId',
                              selected.map((val) => val._id),
                            )
                          }
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="d-flex justify-content-end">
                        <CustomTooltip placement="top" tooltipText={t('FILTER_BUTTON.CLEAR')}>
                          <button aria-label="clear" type="button" onClick={() => onClearClick()} id="Clear" className="btn p-0">
                            <i className="icon-Clear-New f-24" />
                          </button>
                        </CustomTooltip>
                        <CustomTooltip placement="top" tooltipText={t('FILTER_BUTTON.APPLY')}>
                          <button aria-label="apply" type="submit" onClick={() => onApplyClick(selectedItems)} id="Apply" className="btn ml-16 p-0">
                            <i className="icon-Tick-1 f-28" />
                          </button>
                        </CustomTooltip>
                      </div>
                    </Col>
                  </Row>
                </Popover.Content>
              </Popover>
            }
          >
            <i className="icon-Filter f-28" />
          </OverlayTrigger>
        </button>
      </CustomTooltip>
    </div>
  );
}

export default FilterBy;
